<template>
  <v-menu
    v-if="number>0"
    :close-on-content-click="false"
    open-on-hover
    transition="slide-y-transition"
    offset-y
    offset-x
    left
    nudge-right="100"
  >
    <!-- icon -->
    <template
      slot="activator"
    >
      <v-btn
        to="/checkout"
        flat
      >
        <v-badge
          color="red" >
          <span
            slot="badge"
            color="green">{{ number }}</span>
          <v-icon dark>shopping_cart</v-icon>
        </v-badge>
      </v-btn>
    </template>
    <!-- content -->
    <Card
      :margins="false"
      :padding="false"
    >
      <template slot="header">
        Cart
      </template>
      <template slot="extras">
        <v-btn
          to="/checkout"
          light
        >
          Checkout
        </v-btn>
      </template>
      <v-card v-max-height="{height: '80vh'}">
        <v-card light>
          <Camping/>
        </v-card>
        <v-card light>
          <Parking/>
        </v-card>
        <v-card light>
          <GatePasses/>
        </v-card>
        <v-card light>
          <OtherCharges/>
        </v-card>
      </v-card>
    </Card>
  </v-menu>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Camping from '@/components/checkout/Camping'
import Parking from '@/components/checkout/Parking'
import GatePasses from '@/components/checkout/GatePasses'
import OtherCharges from '@/components/checkout/OtherCharges'
export default {
  name: 'CartDropdown',
  components: {
    Camping,
    Parking,
    GatePasses,
    OtherCharges
  },
  computed: {
    number () {
      return this.campsiteBookings.length + this.parkingBookings.length + this.gatePasses.length + this.otherCharges.length
    },
    ...mapGetters({
      campsiteBookings: 'cart/campsiteBookings',
      parkingBookings: 'cart/parkingBookings',
      gatePasses: 'cart/gatePasses',
      otherCharges: 'cart/otherCharges'
    })
  },
  mounted () {
    this.getCart()
  },
  methods: {
    ...mapActions({
      getCart: 'cart/getCart'
    })
  }
}
</script>
